import { deleteAdditionalReferenceV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function deleteAdditionalReference(id: number): Promise<void> {
  await deleteAdditionalReferenceV2(id)
}
